export default {
  computed: {
    hide_price() {
      return this.tender?.biddingType?.isMultistage && this.$can('hide', 'PricesOnPrequalification') && this.tender.tenderStatus?.id == this.statuseKeys.PREQUALIFICATION
    },
    show_reducedPrice() {
      return this.tender?.biddingType?.reducedPriceAvailable && this.$can('use', 'useCriteriaCards') && this.criteryCard?.useReducedPrice
    },
  },
  methods: {
    $_handleTenderingForPercentage(headers) {
      if (this.tender.biddingType.tenderingForPercentage) {
        const removeCols = ['summ']
        removeCols.forEach((removeCol) => {
          const index = headers.findIndex(el => el.value === removeCol)
          if (index !== -1) {
            headers[index].align = ' d-none'
            headers[index].coef_width = '0'
          }
        })
        const item = headers.find(i => i.value === 'price')
        item.text = this.$t('Tenders.DiscountPercentage')
      }
    },
    $_handleReducedPrice(headers) {
      if (this.show_reducedPrice && !this.hide_price) {
        const summIndex = headers.findIndex(el => el.value === 'summ')
        headers.splice(summIndex, 0,
          { text: this.$t('Tenders.GivenPrice'), value: 'reducedPrice', coef_width: '1.5' })
        headers[1].coef_width = '2.5'
        headers[2].coef_width = '1.5'
      }
    },
    $_handlePriceVisibility(headers) {
      if (this.hide_price) {
        headers = headers.filter(el => el.value != 'price' && el.value != 'summ')
        headers[0].coef_width = '3'
        headers[1].coef_width = '3.5'
      }
    },
  },
}
